import { AnyAction } from 'redux';
import { AxiosPromise, AxiosResponse } from 'axios';
import { ServerResponse } from 'data/types';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'data/root.reducers';

export const API_PATH_SECURITY_INFOS = '/securityInfos';

export const GET_SECURITY_INFOS = 'GET_SECURITY_INFOS';
export const GET_SECURITY_INFOS_PENDING = 'GET_SECURITY_INFOS_PENDING';
export const GET_SECURITY_INFOS_FULFILLED = 'GET_SECURITY_INFOS_FULFILLED';
export const GET_SECURITY_INFOS_REJECTED = 'GET_SECURITY_INFOS_REJECTED';
export const CREATE_SECURITY_INFO = 'CREATE_SECURITY_INFO';
export const CREATE_SECURITY_INFO_FULFILLED = 'CREATE_SECURITY_INFO_FULFILLED';
export const CREATE_SECURITY_INFO_REJECTED = 'CREATE_SECURITY_INFO_REJECTED';

export const OPEN_SECURITY_INFO_CREATE_POPUP = 'OPEN_SECURITY_INFO_CREATE_POPUP';
export const CLOSE_SECURITY_INFO_CREATE_POPUP = 'CLOSE_SECURITY_INFO_CREATE_POPUP';
export const SET_SECURITY_INFO_LOADING = 'SET_SECURITY_INFO_LOADING';

export const ACCESS_FUNCTION_SECURITY_INFO_FILTER: SecurityInfoFilterByAccessFunctionAndInterface = {
  ERK_SMF: {
    provisioningInterfaces: [
      { field: 'intfType', value: 'TLS' },
      { field: 'tlsType', value: 'Client' },
      { field: 'tlsVersion', value: 'TLSv1.2' },
    ],
  },
  MV_SMSIWF: {
    provisioningInterfaces: [
      { field: 'intfType', value: 'TLS' },
      { field: 'tlsType', value: 'Client' },
      { field: 'tlsVersion', value: 'TLSv1.2' },
    ],
    dataInterfaces: [
      { field: 'intfType', value: 'TLS' },
      { field: 'tlsType', value: 'Server' },
      { field: 'tlsVersion', value: 'TLSv1.2' },
    ],
  },
};

export interface SecurityInfo {
  id: string
  name: string
  intfType: 'HTTPS' | 'FTPS' | 'TLS' | 'DTLS'
  tlsVersion: 'NONE' | 'SSLv2' | 'SSLv3' | 'TLSv1' | 'TLSv1.1' | 'TLSv1.2' | 'TLSv1.3' | 'DTLSv1' | 'DTLSv1.2' | 'DTLSv1.3'
  tlsType: 'Client' | 'Server'
  authenType: 'SIMPLE' | 'MUTUAL'
  privateKeyFile: string
  certificateFile: string
  passphrase: string
  certificateAuthority: string
  certificateDirectory: string
  description: string
  depth: string
  hostname: string
  cipherFile: string
  catype: 'SELFSIGNED' | 'XCCA',
  aftype?: string,
  litype?: string,
  serialNumber?: string,
  commonName?: string,
  san?: string,
  keyalgorithm?: 'RSA_2048' | 'RSA_4096' |'RSA_8192' | 'ECDSA_256' | 'ECDSA_384' | 'ECDSA_521'
}

export type SecurityInfoFilterByAccessFunctionAndInterface = {
  [accessFunctionTag: string]: SecurityInfoFilterByInterface
}

export type SecurityInfoFilterByInterface = {
  [accessFunctionInterface: string]: SecurityInfoFilter[]
}

export type SecurityInfoFilter = {
  field: keyof SecurityInfo,
  value: string
}

export interface SecurityInfoState {
  entities: SecurityInfo[]
  single: SecurityInfo | null
  createdId: string | null
  ui: SecurityInfoUIState
}

export interface SecurityInfoUIState {
  isCreatePopupOpen: boolean
  isLoading: boolean
}

export interface GetSecurityInfoAction extends AnyAction {
  type: typeof GET_SECURITY_INFOS
  payload: AxiosPromise<ServerResponse<SecurityInfo>>
}

export interface GetSecurityInfoPendingAction extends AnyAction {
  type: typeof GET_SECURITY_INFOS_PENDING
  payload: null
}

export interface GetSecurityInfoFulfilledAction extends AnyAction {
  type: typeof GET_SECURITY_INFOS_FULFILLED
  payload: AxiosResponse<ServerResponse<SecurityInfo>>
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface CreateSecurityInfoThunkAction extends ThunkAction<void, RootState, void, AnyAction> {}

export interface CreateSecurityInfoAction extends AnyAction {
  type: typeof CREATE_SECURITY_INFO
  payload: AxiosPromise<ServerResponse<SecurityInfo>>
}

export interface CreateSecurityInfoFulfilledAction extends AnyAction {
  type: typeof CREATE_SECURITY_INFO_FULFILLED
  payload: AxiosResponse<ServerResponse<SecurityInfo>>
}

export interface CreateSecurityInfoRejectedAction extends AnyAction {
  type: typeof CREATE_SECURITY_INFO_REJECTED
  payload: AxiosResponse<ServerResponse<SecurityInfo>>
}

export interface OpenSecurityInfoCreatePopupAction extends AnyAction {
  type: typeof OPEN_SECURITY_INFO_CREATE_POPUP
  payload: { securityInfo?: SecurityInfo }
}

export interface CloseSecurityInfoCreatePopupAction extends AnyAction {
  type: typeof CLOSE_SECURITY_INFO_CREATE_POPUP
}

export interface SetSecurityInfoLoadingAction extends AnyAction {
  type: typeof SET_SECURITY_INFO_LOADING
  payload: { isLoading: boolean },
}

export type SecurityInfoActionTypes =
  OpenSecurityInfoCreatePopupAction |
  CloseSecurityInfoCreatePopupAction |
  SetSecurityInfoLoadingAction |
  GetSecurityInfoAction |
  GetSecurityInfoPendingAction |
  GetSecurityInfoFulfilledAction |
  CreateSecurityInfoAction |
  CreateSecurityInfoFulfilledAction |
  CreateSecurityInfoRejectedAction;
